<div class="ag-form-control" #viewControl matTooltip="{{ !!hint && formGroup.invalid && formGroup.dirty ? hint : null }}" [class.has-errors]="formGroup.invalid && formGroup.dirty" [formGroup]="formGroup">
  <select formControlName="unit" *ngIf="unitOptions.length > 0">
    <option *ngFor="let u of unitOptions" [value]="u">{{ u }}</option>
  </select>
  <div class="ag-value">
    <input type="number" formControlName="value" step="0.01" placeholder=" " (focus)="onFocus()" (blur)="onBlur()" />
    <label for="value">{{ label }}</label>
  </div>
</div>
